import React from 'react';

const CustomEmailIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M20 7.238L12.072 14.338L4 7.216V19H14V21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V13H20V7.238ZM19.501 5H4.511L12.061 11.662L19.502 5H19.501ZM17.05 19.548C16.9831 19.1857 16.9831 18.8143 17.05 18.452L16.036 17.866L17.036 16.134L18.05 16.72C18.328 16.482 18.649 16.295 19 16.17V15H21V16.17C21.351 16.295 21.672 16.482 21.95 16.72L22.964 16.134L23.964 17.866L22.95 18.452C23.0169 18.8143 23.0169 19.1857 22.95 19.548L23.964 20.134L22.964 21.866L21.95 21.28C21.6699 21.5203 21.3478 21.7067 21 21.83V23H19V21.83C18.6522 21.7067 18.3301 21.5203 18.05 21.28L17.036 21.866L16.036 20.134L17.05 19.548ZM20 20C20.2652 20 20.5196 19.8946 20.7071 19.7071C20.8946 19.5196 21 19.2652 21 19C21 18.7348 20.8946 18.4804 20.7071 18.2929C20.5196 18.1054 20.2652 18 20 18C19.7348 18 19.4804 18.1054 19.2929 18.2929C19.1054 18.4804 19 18.7348 19 19C19 19.2652 19.1054 19.5196 19.2929 19.7071C19.4804 19.8946 19.7348 20 20 20Z"
      fill="currentColor"
    />
  </svg>
);

export default CustomEmailIcon;
